module.exports = __webpack_public_path__ + "img/公司logo.6f27b2f6.png";